// Metadatos de las rutas públicas prerenderizadas. UNA fuente, usada por scripts/prerender.mjs para
// escribir el <head> de cada HTML. Se mantiene como datos (no dentro del JSX) a propósito: es portable
// a otro generador si algún día el marketing se separa. Ver docs/SEO_GEO_PLAN.md §2 y §3.5.
export const SITE_ORIGIN = "https://matchbot.digitalmatchglobal.com";

export const PUBLIC_ROUTE_META = {
  "/": {
    title: "MatchBot | Todas tus conversaciones bajo control",
    description:
      "Automatiza consultas, califica oportunidades y deriva conversaciones a tu equipo con MatchBot, la solución de IA de Digital Match para WhatsApp e Instagram.",
  },
  "/producto": {
    title: "Producto: IA y bandeja para WhatsApp e Instagram | MatchBot",
    description:
      "Asistente de IA con la información de tu negocio, bandeja compartida para tu equipo, contactos, plantillas y campañas. Para WhatsApp e Instagram.",
  },
  "/como-funciona": {
    title: "Cómo funciona MatchBot: de tu WhatsApp a atención con IA",
    description:
      "Conectamos tu número por la API oficial, cargamos la información de tu negocio, probamos con preguntas reales y activamos. Así es la puesta en marcha.",
  },
  "/cuanto-cuesta-whatsapp-api": {
    title: "Cuánto cuesta la API de WhatsApp y qué cubre MatchBot",
    description:
      "Meta cobra por mensaje según tipo y país y MatchBot no agrega recargo. Qué cubre la suscripción y qué cambia frente a la app gratuita de WhatsApp Business.",
  },
  "/como-elegir": {
    title: "Cómo atender WhatsApp: app, CRM, a medida o MatchBot",
    description:
      "App gratuita de WhatsApp Business, CRM o plataforma autogestionada, desarrollo a medida o MatchBot: cuándo conviene cada una y cuándo no.",
  },
  "/precios": {
    title: "Precios | MatchBot",
    description:
      "Planes de MatchBot para atender WhatsApp e Instagram con IA, una bandeja compartida y acceso para tu equipo. Elegí según los canales y el volumen que necesitás.",
  },
  "/seguridad": {
    title: "Seguridad y privacidad de tus conversaciones | MatchBot",
    description:
      "Canales oficiales de Meta, aislamiento entre organizaciones, roles y permisos, mensajes firmados y qué datos se comparten con cada proveedor.",
  },
  "/terminos": {
    title: "Términos y condiciones | MatchBot",
    description: "Términos y condiciones de uso del servicio MatchBot.",
  },
  "/privacidad": {
    title: "Política de privacidad | MatchBot",
    description: "Cómo MatchBot trata y protege los datos personales y de las conversaciones de sus clientes.",
  },
  "/reembolsos": {
    title: "Política de reembolsos | MatchBot",
    description: "Condiciones de cancelación y reembolso de las suscripciones de MatchBot.",
  },
};

const normalizePath = (pathname = "/") => {
  const path = String(pathname).split(/[?#]/)[0] || "/";
  return path.length > 1 ? path.replace(/\/+$/, "") : "/";
};

export const canonicalUrl = (pathname) => `${SITE_ORIGIN}${normalizePath(pathname)}`;

/**
 * Metadatos de una ruta. Las rutas sin HTML propio (login, /app/*, 404) caen en los de la home: es lo que
 * trae el shell de la SPA, así que el cliente nunca deja un título ajeno al sitio.
 */
export function resolveRouteMeta(pathname) {
  const path = normalizePath(pathname);
  const known = Object.prototype.hasOwnProperty.call(PUBLIC_ROUTE_META, path);
  const { title, description } = PUBLIC_ROUTE_META[known ? path : "/"];
  return { title, description, url: canonicalUrl(known ? path : "/"), known };
}

// Página 404 (build/404.html). Sin canonical ni og:url: una página que no existe no tiene URL canónica, y va con noindex.
export const NOT_FOUND_META = {
  title: "Página no encontrada | MatchBot",
  description: "La página que buscás no existe o cambió de lugar.",
};
